<template>
  <div class="form-page">
    <div class="form-button form-var auto-height"
      :class="{'success': history[currentStep].value === value}"
      v-for="(value, name, index) in history[currentStep].field.translate"
      v-bind:key="index"
      :name="history[currentStep].name"
      @click="handleInput(value)"
    >{{name}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { generateSalaryCycleDates } from '../../helpers'

export default {
  name: 'ButtonPicker',
  mounted () {
    const current = this.history[this.currentStep]
    if (!Object.keys(current.field.translate).length) {
      this.$store.commit('UPDATE_FIELD', {field: {...current.field, translate: {[current.value]: current.value}}})
    }
  },
  computed: mapState({
    history: state => state.history,
    currentStep: state => state.currentStep,
    country: state => state.additionalParams.country
  }),
  methods: {
    handleInput (val) {
      const current = this.history[this.currentStep]
      if (current.name === 'colony' && +this.country === 2) {
        let auto = current.field['additionalColonyInfo'][val]
        let autoFields = ['city', 'municipality', 'state']
        for (let i in autoFields) {
          this.$store.dispatch('insertOrUpdateField', {
            index: this.currentStep + 1 + +i,
            data: { name: autoFields[i], isValid: true, value: auto[autoFields[i]], skip: true }
          })
        }
      }
      if (current.name === 'salary_cycle' && +this.country === 2) {
        const translate = {}
        const values = generateSalaryCycleDates(val)
        values.forEach(x => translate[x] = x)
        const field = { ...this.$store.getters.getFieldInfoByName('salary_cycle_value'), translate }
        this.$store.dispatch('insertOrUpdateField', {
          index: this.currentStep + 1,
          data: { name: 'salary_cycle_value', field}
        })
      }
      this.$store.commit('UPDATE_FIELD', {isValid: true, value: val})
      this.$store.dispatch('nextStepPrepare', +1)
    }
  }
}
</script>

<style scoped>
 .auto-height {
   height: auto !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/fields/ButtonPicker.vue